import * as React from 'react';
import { isEmpty } from 'ramda';

import { ViewAllReport as ViewAllReportComponent } from '../../components/ViewAllReport';
import { useCurrentScrollingBlock } from '../Scrolling';
import { useReportItems } from './utils/useReportItems';
import { useItemClickHandler } from './utils/useItemClickHandler';

export function ViewAllReportContainer() {
  const reportItems = useReportItems();
  const currentReportItem = useCurrentScrollingBlock();
  const handleItemClick = useItemClickHandler();

  if (isEmpty(reportItems)) {
    return null;
  }

  return (
    <ViewAllReportComponent
      reportItems={reportItems}
      currentReportItem={currentReportItem ? currentReportItem.id : null}
      onItemClick={handleItemClick}
    />
  );
}
